export function isBackendError(value) {
	return value !== undefined && value !== null && typeof value === 'object'
		&& value.hasOwnProperty('code') && typeof value.code === 'number'
		&& value.hasOwnProperty('message') && typeof value.message === 'string';
}
